export {
  PussInBootsTopicOfTopicPage as default,
  getPussInBootsTopicOfTopicServerSideProps as getServerSideProps,
} from 'src/features/PussInBoots';
